@if (visible) {
<p-dialog [modal]="true" [(visible)]="visible" [draggable]="false" [closable]="false" [showHeader]="false"
  [closeOnEscape]="false">
  <ng-container [ngTemplateOutlet]="sessionExpired ? expiredTemplate : warningTemplate"></ng-container>
</p-dialog>
}

<ng-template #warningTemplate>
  <div class="flex flex-column warningTemplate" [style]="{ width: '487px', height: '502px' }">
    <div class="flex flex-column flex-grow-1 align-items-center justify-content-center text-center">
      <p class="text-3xl"><strong>{{"Idle_Keep_Session_Active" | translate}}</strong></p>
      <div>
        <p-knob [(ngModel)]="countdown" [min]="0" [max]="maxCountdown" [disabled]="true" [valueTemplate]="formatTime"
          [strokeWidth]="8" [ngClass]="{'warning': isWarning}">
        </p-knob>
        <p class="text-lg text-color-secondary">{{"Idle_Remaining_Time" | translate}}</p>
      </div>
      <p class="text-2xl">{{"Idle_Warning_Security_Message" | translate}}</p>
    </div>
    <div class="flex flex-row-reverse align-items-center justify-content-around pb-8">
      <button id="keepSessionActive" class="btn" (click)="keepSessionActive()">{{"Idle_Stay_Signed_Button" |
        translate}}</button>
      <button id="endSession" class="btn border-none" (click)="endSession()">{{"Idle_Log_Out_Button" |
        translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #expiredTemplate>
  <div id="expiredTemplate" class="flex flex-column align-items-center justify-content-center text-center"
    [style]="{ width: '487px', height: '299px' }">
    <div class="flex flex-column flex-grow-1 align-items-center justify-content-evenly">
      <p class="text-3xl"><strong>{{"Idle_Session_Expired" | translate}}</strong></p>
      <div>
        <p class="text-2xl text-color-secondary">{{"Idle_Session_Expired_Message" | translate}}</p>
        <p class="text-2xl text-color-secondary">{{"Idle_Session_Expired_Message_Login" | translate}}</p>
      </div>
    </div>
  </div>
</ng-template>